export const ELDERS_DECISIONS_PATH = "/child-protection/clearances/elders-approval";
